import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojejuricab() {



    const cardData = {

keyword: "Pune to Jejuri Cab",

headingDescription:
    "Rising Cab Service provides reliable and comfortable Pune to Jejuri Cab services for pilgrims, families, and tourists visiting the famous Khandoba Temple. We offer one-way and round-trip taxi services with well-maintained Sedan, SUV, Innova Crysta, and Tempo Traveller vehicles driven by experienced chauffeurs. Our affordable fares, punctual pickups, and 24/7 availability ensure a safe and hassle-free journey. Whether for a spiritual visit, sightseeing, or a family outing, Rising Cab Service makes your Pune to Jejuri trip convenient and enjoyable.",

topPlaces: [
    {
        title: "Jejuri Khandoba Temple",
        description:
            "Jejuri Khandoba Temple is the most famous attraction in the town and one of Maharashtra's most important pilgrimage sites. Dedicated to Lord Khandoba, an incarnation of Lord Shiva, the temple sits atop a hill and is reached by climbing hundreds of stone steps. The temple is renowned for its vibrant Bhandara festival, where devotees shower turmeric powder, creating a spectacular golden atmosphere."
    },
    {
        title: "Kadepathar Temple",
        description:
            "Kadepathar Temple is believed to be the original abode of Lord Khandoba before the main Jejuri Temple was established. Located on a scenic hilltop, the temple offers a peaceful environment and panoramic views of the surrounding countryside, making it a popular spiritual and sightseeing destination."
    },
    {
        title: "Jejuri Fort",
        description:
            "Jejuri Fort surrounds the famous temple complex and reflects the region's rich Maratha history. The ancient stone walls, gateways, and elevated viewpoints provide visitors with beautiful landscapes and an opportunity to explore the historical significance of the area."
    },
    {
        title: "Malhargad Fort",
        description:
            "Malhargad Fort, also known as Sonori Fort, is the last fort built during the Maratha Empire. Located near Jejuri, it is a favorite destination for history enthusiasts and trekkers. The fort offers scenic trekking trails and breathtaking views of the Sahyadri hills and nearby villages."
    },
    {
        title: "Mastani Talav",
        description:
            "Mastani Talav is a historic lake associated with the legendary love story of Peshwa Bajirao and Mastani. Surrounded by peaceful landscapes, the lake is a relaxing destination for visitors interested in history, photography, and nature."
    },
    {
        title: "Narayanpur Datta Temple",
        description:
            "Narayanpur Datta Temple is a revered spiritual destination dedicated to Lord Dattatreya. The temple attracts thousands of devotees seeking blessings and is known for its calm surroundings, traditional architecture, and religious significance."
    },
    {
        title: "Prati Balaji Temple",
        description:
            "Prati Balaji Temple at Narayanpur is a magnificent replica of the famous Tirupati Balaji Temple. Built with intricate South Indian architecture, the temple attracts devotees and tourists alike for its beautiful carvings and peaceful spiritual atmosphere."
    },
    {
        title: "Purandar Fort",
        description:
            "Purandar Fort is one of Maharashtra's most historically significant hill forts and is closely associated with Chhatrapati Shivaji Maharaj. The fort offers spectacular mountain views, ancient structures, and trekking opportunities while showcasing the glorious Maratha heritage."
    },
    {
        title: "Chambli Dam",
        description:
            "Chambli Dam is a scenic destination near Jejuri known for its tranquil waters and natural beauty. The area is ideal for picnics, birdwatching, and spending quality time with family while enjoying the peaceful countryside."
    },
    {
        title: "Baneshwar Temple",
        description:
            "Baneshwar Temple is an ancient Shiva temple surrounded by lush greenery and a protected forest area. The temple complex features beautiful stone architecture, small water streams, and a serene environment, making it a popular stop for pilgrims and nature lovers visiting the Jejuri region."
    }
],



services: [
  {
    name: "Pune to Jejuri Cab Fare",
    description: "Rising Cab Service offers transparent Pune to Jejuri Cab Fare designed for affordable and comfortable pilgrimage travel to Shri Khandoba Temple at Jejuri. Our pricing is based on vehicle type, trip duration, and travel plan, ensuring clear, upfront rates with no hidden charges. Enjoy safe AC rides, professional drivers, and smooth highway travel for a stress-free journey."
  },
  {
    name: "Pune to Jejuri Cab Price",
    description: "Check Pune to Jejuri Cab Price with Rising Cab Service for budget-friendly and reliable travel options. We offer competitive pricing for sedans, SUVs, Innova Crysta, and premium vehicles, making your temple visit economical, safe, and comfortable with doorstep pickup and timely service."
  },
  {
    name: "Pune to Jejuri Cab Service",
    description: "Book Pune to Jejuri Cab Service for a smooth and devotional journey to Jejuri Khandoba Temple. We provide well-maintained vehicles, experienced chauffeurs, flexible booking options, and 24x7 availability for family trips, solo travel, and group pilgrimages."
  },
  {
    name: "Pune to Jejuri Car Rental",
    description: "Rising Cab Service offers Pune to Jejuri Car Rental with flexible travel options including hourly, one-way, and round-trip packages. Choose from sedans, SUVs, and premium cars based on your comfort and group size for a convenient pilgrimage experience."
  },
  {
    name: "Pune to Jejuri Taxi",
    description: "Reliable Pune to Jejuri Taxi service for safe and comfortable travel to Shri Khandoba Temple. Enjoy clean AC cars, professional drivers, and smooth road journeys with affordable pricing and timely pickup from any location in Pune."
  },
  {
    name: "Pune to Jejuri Taxi Fare",
    description: "Get transparent Pune to Jejuri Taxi Fare with clear pricing and no hidden charges. We offer cost-effective packages suitable for solo travelers, families, and groups visiting Jejuri for darshan and religious purposes."
  },
  {
    name: "Pune to Jejuri Cab",
    description: "Book Pune to Jejuri Cab for a comfortable and safe pilgrimage journey. Our service includes doorstep pickup, AC vehicles, experienced drivers, and flexible travel options designed for a smooth and peaceful temple visit."
  },
  {
    name: "Pune to Jejuri Taxi Service",
    description: "Trusted Pune to Jejuri Taxi Service offering reliable and timely travel solutions for devotees visiting Jejuri. We ensure comfortable seating, safe driving, and professional service for a stress-free journey experience."
  },
  {
    name: "Pune to Jejuri Cab Booking",
    description: "Easy Pune to Jejuri Cab Booking system for instant reservations with multiple vehicle options. Get quick confirmation, flexible pickup timing, and 24x7 customer support for a seamless travel experience."
  },
  {
    name: "Pune to Jejuri One Way Cab",
    description: "Affordable Pune to Jejuri One Way Cab service for drop-only travel without return charges. Ideal for budget travelers looking for safe, clean, and economical intercity cab service with professional drivers."
  },
  {
    name: "Pune to Jejuri Round Trip Cab",
    description: "Book Pune to Jejuri Round Trip Cab for same-day return journeys with comfortable waiting time at the temple. Perfect for family and group pilgrimages with flexible scheduling and cost-effective packages."
  },
  {
    name: "Pune to Jejuri Darshan Cab",
    description: "Special Pune to Jejuri Darshan Cab service designed for devotees visiting Shri Khandoba Temple. Enjoy door-to-door pickup, smooth travel, and return options for a peaceful and well-organized darshan experience."
  },
  {
    name: "Pune to Jejuri Temple Cab",
    description: "Reliable Pune to Jejuri Temple Cab service offering safe and comfortable travel directly to the temple. We ensure professional drivers, clean AC vehicles, and smooth highway rides for a hassle-free pilgrimage."
  },
  {
    name: "Pune to Jejuri Innova Crysta Cab",
    description: "Premium Pune to Jejuri Innova Crysta Cab service for families and groups seeking extra comfort and spacious seating. Enjoy luxury travel with smooth suspension and experienced drivers for a relaxing journey."
  },
  {
    name: "Pune to Jejuri AC Cab Service",
    description: "Comfortable Pune to Jejuri AC Cab Service with clean, air-conditioned vehicles for a pleasant travel experience. Ideal for short pilgrimage trips with safety, comfort, and affordability."
  },
  {
    name: "Pune to Jejuri Outstation Cab",
    description: "Reliable Pune to Jejuri Outstation Cab service for safe intercity travel with professional drivers, flexible booking options, and well-maintained vehicles suitable for all types of travelers."
  },
  {
    name: "Pune to Jejuri Tour Package",
    description: "Complete Pune to Jejuri Tour Package including pickup, temple visit, darshan time, and return journey. Perfect for families and devotees looking for a well-planned spiritual trip experience."
  },
  {
    name: "Pune to Jejuri Online Cab Booking",
    description: "Easy Pune to Jejuri Online Cab Booking system for instant reservations, transparent pricing, and multiple vehicle options for a smooth and quick travel experience."
  },
  {
    name: "Pune to Jejuri Same Day Return Cab",
    description: "Pune to Jejuri Same Day Return Cab service designed for quick pilgrimage trips with early pickup, temple darshan, waiting time, and return journey on the same day."
  },
  {
    name: "Pune to Jejuri Family Cab Service",
    description: "Comfortable Pune to Jejuri Family Cab Service offering safe, spacious, and reliable travel for families visiting the temple together. Enjoy smooth rides and professional service."
  },
  {
    name: "Pune to Jejuri SUV Cab Booking",
    description: "Book Pune to Jejuri SUV Cab Booking for group travel with extra space, comfort, and powerful vehicles suitable for temple trips and long drives."
  },
  {
    name: "Pune to Jejuri Temple Tour Taxi",
    description: "Reliable Pune to Jejuri Temple Tour Taxi service offering complete travel support for devotees with comfortable vehicles, experienced drivers, and smooth pilgrimage planning."
  },
  {
    name: "Pune to Jejuri Khandoba Temple Cab",
    description: "Dedicated Pune to Jejuri Khandoba Temple Cab service for devotees visiting Shri Khandoba Temple with safe driving, timely pickup, and comfortable AC travel."
  },
  {
    name: "Pune to Jejuri Darshan Taxi",
    description: "Pune to Jejuri Darshan Taxi service ensures smooth and peaceful temple visits with professional drivers, flexible timing, and comfortable vehicles."
  },
  {
    name: "Pune to Jejuri Weekend Trip Cab",
    description: "Perfect Pune to Jejuri Weekend Trip Cab for short spiritual getaways with family or friends, offering comfortable rides and flexible return options."
  },
  {
    name: "Pune to Jejuri Innova Taxi",
    description: "Premium Pune to Jejuri Innova Taxi service ideal for families seeking extra space, comfort, and smooth travel for temple visits."
  },
  {
    name: "Pune to Jejuri Luxury Cab Service",
    description: "Luxury Pune to Jejuri Cab Service offering premium vehicles, professional chauffeurs, and enhanced comfort for a high-quality pilgrimage experience."
  },
  {
    name: "Pune to Jejuri Tourist Taxi",
    description: "Reliable Pune to Jejuri Tourist Taxi service for guided and comfortable travel experiences for pilgrims and visitors."
  },
  {
    name: "Pune to Jejuri Day Trip Cab",
    description: "Convenient Pune to Jejuri Day Trip Cab service for same-day temple visits with early pickup, darshan, and return journey included."
  }
],

tableData: [
  ["Pune to Jejuri Cab Fare", "Pune to Jejuri Cab Price"],
  ["Pune to Jejuri Cab Service", "Pune to Jejuri Car Rental"],
  ["Pune to Jejuri Taxi", "Pune to Jejuri Taxi Fare"],
  ["Pune to Jejuri Cab Booking", "Pune to Jejuri One Way Cab"],
  ["Pune to Jejuri Round Trip Cab", "Pune to Jejuri Darshan Cab"],
  ["Pune to Jejuri Temple Cab", "Pune to Jejuri Innova Crysta Cab"],
  ["Pune to Jejuri AC Cab Service", "Pune to Jejuri Outstation Cab"],
  ["Pune to Jejuri Tour Package", "Pune to Jejuri Online Cab Booking"],
  ["Pune to Jejuri Same Day Return Cab", "Pune to Jejuri Family Cab Service"],
  ["Pune to Jejuri SUV Cab Booking", "Pune to Jejuri Temple Tour Taxi"]
],



whychoose: [
    {
        WhyChooseheading: "Trusted Pune to Jejuri Cab Service",
        WhyChoosedescription: "Rising Cab Service offers dependable Pune to Jejuri cab services for devotees, families, tourists, and groups traveling to the famous Khandoba Temple."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Temple Visits",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, and spacious vehicles to ensure a relaxing and comfortable journey to Jejuri."
    },
    {
        WhyChooseheading: "Professional and Courteous Drivers",
        WhyChoosedescription: "Our experienced drivers are familiar with the Pune to Jejuri route and provide safe, punctual, and hassle-free transportation."
    },
    {
        WhyChooseheading: "Affordable Jejuri Cab Packages",
        WhyChoosedescription: "Rising Cab Service provides budget-friendly Pune to Jejuri taxi services with transparent pricing and no hidden charges."
    },
    {
        WhyChooseheading: "One Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose one-way transfers, return journeys, or customized travel packages based on their schedule and requirements."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune",
        WhyChoosedescription: "We offer convenient pickup services from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Viman Nagar, Pune Airport, and all major Pune locations."
    },
    {
        WhyChooseheading: "Ideal for Religious and Family Travel",
        WhyChoosedescription: "Our Pune to Jejuri cab service is perfect for temple visits, family outings, spiritual tours, and senior citizen travel."
    },
    {
        WhyChooseheading: "24/7 Booking Support",
        WhyChoosedescription: "Rising Cab Service provides round-the-clock booking assistance, helping customers plan their Jejuri trip conveniently."
    }
]
};

const faqData = [
    {
        question: "Do you provide Pune to Jejuri Cab Service?",
        answer: "Yes, Rising Cab Service provides dedicated cab services from Pune to Jejuri for temple visits, family trips, and sightseeing."
    },
    {
        question: "How far is Jejuri from Pune?",
        answer: "Jejuri is located approximately 50 to 60 kilometers from Pune depending on the pickup location and travel route."
    },
    {
        question: "Can I book a one-way cab from Pune to Jejuri?",
        answer: "Yes, we offer both one-way and round-trip cab services for Jejuri travel."
    },
    {
        question: "Which vehicles are available for Jejuri travel?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles for group travel."
    },
    {
        question: "Do you offer same-day return trips to Jejuri?",
        answer: "Yes, customers can book same-day return packages for Jejuri Temple Darshan."
    },
    {
        question: "Is the cab service suitable for senior citizens?",
        answer: "Yes, our comfortable vehicles and experienced drivers make travel convenient for senior citizens and families."
    },
    {
        question: "Do you provide pickup from Pune Airport?",
        answer: "Yes, pickup services are available from Pune Airport, Railway Station, hotels, homes, and major Pune locations."
    },
    {
        question: "Are your drivers familiar with the Jejuri route?",
        answer: "Yes, our drivers regularly operate on the Pune to Jejuri route and know the best travel routes."
    },
    {
        question: "Can I include nearby sightseeing places during the trip?",
        answer: "Yes, customized travel plans can include nearby attractions and religious destinations around Jejuri."
    },
    {
        question: "How can I book a Pune to Jejuri Cab?",
        answer: "You can book your cab easily through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahesh Shinde",
        feedback:
            "Our Jejuri Temple visit was smooth and comfortable with Rising Cab Service. The driver was professional, and the vehicle was clean and well-maintained.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Deshpande",
        feedback:
            "We traveled to Jejuri with our family and had a wonderful experience. The cab arrived on time, and the journey was safe, comfortable, and stress-free.",
        rating: 5
    }
];





















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Jejuri Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-jejuri-cab.jpg",
"description": "Book Pune to Jejuri Cab Service with Rising Cab Service for comfortable temple visits, darshan trips, and outstation travel. Enjoy affordable fares, AC cabs, professional drivers, and one-way or round-trip taxi services to Jejuri.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-jejuri-cab"
}
};





    return (
        <div>


<Helmet>
  <title>Pune to Jejuri Cab Service | Temple Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Jejuri Cab Service at affordable rates. Comfortable AC taxi service for Jejuri temple darshan with one-way, round-trip, sightseeing, and outstation cab options."
/>

<meta
 name="keywords"
 content="Pune to jejuri cab fare, Pune to jejuri cab price, Pune to jejuri cab service, Pune to jejuri car rental, Pune to jejuri taxi, Pune to jejuri taxi fare, Pune to Jejuri Cab, Pune to Jejuri Taxi Service, Pune to Jejuri Cab Booking, Pune to Jejuri One Way Cab, Pune to Jejuri Round Trip Cab, Pune to Jejuri Darshan Cab, Pune to Jejuri Temple Cab, Pune to Jejuri Taxi Fare, Pune to Jejuri Innova Crysta Cab, Pune to Jejuri AC Cab Service, Pune to Jejuri Outstation Cab, Pune to Jejuri Tour"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojejuricab;